import React, { useEffect, useState } from "react";
import FreePage from "./FreePage.js";
import "./Replacing.css"
import ProfileCard from "./ProfileCard.js";
import { changeReturnStatus, getReturnOrders } from "../../network/api/order.js";
import ReturnForm from "./ReturnForm.js";
import StatusConfirmationModal from "./StatusConfirmationModal.js";
import { useTranslation } from "react-i18next";

export default function RecoveryComp() {
    const { t } = useTranslation();
  
  const [free, setFree] = useState(false);
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [refreshComponent, setRefreshComponent] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowDeleteModal = (orderId) => {
    setSelectedOrderId(orderId);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setSelectedOrderId(null);
  };

  const handleConfirmDelete = () => {
    if (selectedOrderId) {
      changeReturnStatus(selectedOrderId).then(() => {
        setRefreshComponent((prev) => !prev);
        handleCloseDeleteModal();
      });
    }
  };

  useEffect(() => {
    getReturnOrders().then((result) => {
      if (result && result.data.length > 0) {
        setOrders(result.data);
        setFree(false);
      } else {
        setFree(true);
      }
    });
  }, [refreshComponent]);

  return (
    <div>
      {free && (
        <>
          <FreePage
            prev={true}
            prevName="اعرض  طلبات الإرجاع السابقة "
            showBtns={true}
            image={ReturnIcon}
            contentP="لا يوجد طلب الإرجاع "
            contentSpan="بحاجة الي تقديم طلب ؟ اضغط علي الزر ادناه!"
            btn="طلب استرجاع جديد"
            btnValue={handleShowModal}
          />
          <ReturnForm
           show={showModal} 
           setShowModal={setShowModal}
           onHide={handleCloseModal}
            setRefreshComponent={setRefreshComponent} 
            refreshComponent={refreshComponent} 
            />
        </>
      )}

      {!free && (
        <>
          <div
            className="d-flex justify-content-center p-1"
            style={{ marginTop: "32px", marginBottom: "32px " }}
          >
            <button style={{ backgroundColor: "#C99700", border: "none" , borderRadius:"8px" }} onClick={handleShowModal}>طلب استرجاع جديد</button>
            <ReturnForm show={showModal} onHide={handleCloseModal} setRefreshComponent={setRefreshComponent} refreshComponent={refreshComponent} />
          </div>
          {orders?.map((order, index) => (
            <div>
              {order.products.map((product, index) => (
                <>
                  <div key={index} className="replace-product-container">
                    <div className="container-box">
                      <img src={product.image[0].secure_url} alt="" />
                      <div className="container-box-info">
                        <h5>{product.name}</h5>
                        <p className="category m-0 p-0">{product.category}</p>
                        <p className="price m-0 p-0"><span> {t('curency')}  </span>{order.totalPrice}</p>
                        <div className="status">
                          <p>{order?.returnrequest}</p>
                        </div>
                      </div>
                    </div>
                    <p onClick={() => handleShowDeleteModal(order._id)}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.0036 6.72998C20.9836 6.72998 20.9536 6.72998 20.9236 6.72998C15.6336 6.19998 10.3536 5.99998 5.12358 6.52998L3.08358 6.72998C2.66358 6.76998 2.29358 6.46998 2.25358 6.04998C2.21358 5.62998 2.51358 5.26998 2.92358 5.22998L4.96358 5.02998C10.2836 4.48998 15.6736 4.69998 21.0736 5.22998C21.4836 5.26998 21.7836 5.63998 21.7436 6.04998C21.7136 6.43998 21.3836 6.72998 21.0036 6.72998Z" fill="#C8C8C8" />
                        <path d="M8.50074 5.72C8.46074 5.72 8.42074 5.72 8.37074 5.71C7.97074 5.64 7.69074 5.25 7.76074 4.85L7.98074 3.54C8.14074 2.58 8.36074 1.25 10.6907 1.25H13.3107C15.6507 1.25 15.8707 2.63 16.0207 3.55L16.2407 4.85C16.3107 5.26 16.0307 5.65 15.6307 5.71C15.2207 5.78 14.8307 5.5 14.7707 5.1L14.5507 3.8C14.4107 2.93 14.3807 2.76 13.3207 2.76H10.7007C9.64074 2.76 9.62074 2.9 9.47074 3.79L9.24074 5.09C9.18074 5.46 8.86074 5.72 8.50074 5.72Z" fill="#C8C8C8" />
                        <path d="M15.2104 22.7501H8.79039C5.30039 22.7501 5.16039 20.8201 5.05039 19.2601L4.40039 9.19007C4.37039 8.78007 4.69039 8.42008 5.10039 8.39008C5.52039 8.37008 5.87039 8.68008 5.90039 9.09008L6.55039 19.1601C6.66039 20.6801 6.70039 21.2501 8.79039 21.2501H15.2104C17.3104 21.2501 17.3504 20.6801 17.4504 19.1601L18.1004 9.09008C18.1304 8.68008 18.4904 8.37008 18.9004 8.39008C19.3104 8.42008 19.6304 8.77007 19.6004 9.19007L18.9504 19.2601C18.8404 20.8201 18.7004 22.7501 15.2104 22.7501Z" fill="#C8C8C8" />
                        <path d="M13.6581 17.25H10.3281C9.91813 17.25 9.57812 16.91 9.57812 16.5C9.57812 16.09 9.91813 15.75 10.3281 15.75H13.6581C14.0681 15.75 14.4081 16.09 14.4081 16.5C14.4081 16.91 14.0681 17.25 13.6581 17.25Z" fill="#C8C8C8" />
                        <path d="M14.5 13.25H9.5C9.09 13.25 8.75 12.91 8.75 12.5C8.75 12.09 9.09 11.75 9.5 11.75H14.5C14.91 11.75 15.25 12.09 15.25 12.5C15.25 12.91 14.91 13.25 14.5 13.25Z" fill="#C8C8C8" />
                      </svg>
                    </p>
                  </div>
                  <StatusConfirmationModal
                  show={showDeleteModal}
                  handleClose={handleCloseDeleteModal}
                  handleDelete={handleConfirmDelete}
                  
                  />
                </>
              ))}
            </div>
          ))}  
        </>
      )}
    </div>
  );
}

const ReturnIcon = (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_1606_10383" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
      <path d="M0 0H20V20H0V0Z" fill="white" />
    </mask>
    <g mask="url(#mask0_1606_10383)">
      <path d="M19.9043 9.80933L17.5307 6.24821C17.4723 6.16042 17.3776 6.10847 17.2765 6.10847C17.1755 6.10847 17.0807 6.16042 17.0224 6.24821L14.6487 9.80933C14.5815 9.91042 14.5728 10.0427 14.6263 10.1528C14.6798 10.2626 14.7864 10.3317 14.9029 10.3317H15.8614C15.6984 13.9471 12.8789 16.8348 9.4363 16.8348C5.88932 16.8348 3.00352 13.7692 3.00352 10.0005C3.00352 6.23208 5.88932 3.16646 9.4363 3.16646C10.2679 3.16646 11.0779 3.33282 11.8432 3.66119C11.9592 3.7111 12.0916 3.68218 12.1801 3.58825L13.9504 1.70736C14.0201 1.63339 14.0527 1.52872 14.0384 1.42506C14.024 1.32141 13.9642 1.23106 13.8774 1.18166C12.5203 0.408733 10.9846 0 9.4363 0C6.92207 0 4.55806 1.04039 2.78024 2.92921C1.00241 4.81803 0.0234375 7.32929 0.0234375 10.0005C0.0234375 12.672 1.00241 15.1833 2.78024 17.0721C4.55806 18.9609 6.92207 20.0013 9.4363 20.0013C11.9505 20.0013 14.3143 18.9609 16.0921 17.0721C17.7964 15.2613 18.7667 12.8788 18.8441 10.3317H19.6502C19.7666 10.3317 19.8732 10.2626 19.9267 10.1528C19.9803 10.0427 19.9716 9.91042 19.9043 9.80933ZM18.5374 9.66958C18.3655 9.66958 18.2258 9.81777 18.2258 10.0005C18.2258 15.15 14.2829 19.3392 9.4363 19.3392C4.58941 19.3392 0.646509 15.15 0.646509 10.0005C0.646509 4.8513 4.58941 0.662111 9.4363 0.662111C10.7403 0.662111 12.0347 0.972308 13.2056 1.56276L11.883 2.96785C11.1006 2.66022 10.2786 2.50435 9.4363 2.50435C5.54572 2.50435 2.38045 5.86712 2.38045 10.0005C2.38045 14.1342 5.54572 17.4969 9.4363 17.4969C13.3266 17.4969 16.4919 14.1342 16.4919 10.0005C16.4919 9.81777 16.3523 9.66958 16.1804 9.66958H15.5052L17.2765 7.01218L19.0476 9.66958H18.5374ZM12.6693 6.54663C12.3337 6.5474 12.0183 6.6874 11.7808 6.94129L8.73847 10.2206L7.09279 8.47205C6.85479 8.21944 6.53868 8.08021 6.20206 8.08021C5.86569 8.08021 5.54934 8.21944 5.31134 8.47205C5.07335 8.72492 4.94242 9.06096 4.94242 9.41851C4.94242 9.77605 5.07335 10.1121 5.31134 10.365L7.85089 13.0628C8.09636 13.3239 8.41898 13.4541 8.74161 13.4541C9.064 13.4541 9.38662 13.3236 9.63233 13.0628C10.6677 11.9628 11.2028 11.3808 11.8222 10.7072C12.2953 10.1927 12.7843 9.66063 13.5641 8.82371C13.8009 8.57084 13.9309 8.23505 13.9299 7.87828C13.929 7.5215 13.7973 7.18673 13.5593 6.93514C13.3221 6.68458 13.0074 6.54663 12.6729 6.54663C12.6717 6.54663 12.6705 6.54663 12.6693 6.54663ZM13.3069 7.88007C13.3073 8.05999 13.2418 8.22942 13.1219 8.35739C12.3402 9.19635 11.8283 9.75302 11.3766 10.2444C10.7584 10.9168 10.2245 11.4972 9.19179 12.5947C8.94343 12.8583 8.53955 12.8583 8.29143 12.5947L5.75188 9.8966C5.6318 9.76889 5.56549 9.5992 5.56549 9.41851C5.56549 9.23782 5.6318 9.06787 5.75188 8.94016C5.8722 8.81245 6.03207 8.74207 6.20206 8.74207C6.37206 8.74207 6.53193 8.81245 6.65225 8.94016L8.51977 10.9244C8.57861 10.9866 8.65914 11.022 8.74113 11.0214C8.82432 11.0209 8.90365 10.9856 8.962 10.9227L12.2235 7.40709C12.3428 7.27938 12.502 7.209 12.6712 7.20849C12.672 7.20849 12.6725 7.20849 12.6729 7.20849C12.8417 7.20849 13.0004 7.2781 13.12 7.40453C13.2401 7.53122 13.3064 7.70014 13.3069 7.88007Z" fill="white" />
    </g>
  </svg>
)